import { render } from "./PlantJournals.vue?vue&type=template&id=551f05fe"
import script from "./PlantJournals.vue?vue&type=script&lang=js"
export * from "./PlantJournals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__